// @vendors
const moment = require('moment');

// @utilities
const { APIPost } = require('utilities/APIRequestHelper');
const apiURLBuilder = require('core/apiURLBuilder');
const RAAccountsHelper = require('../utilities/RAAccountsHelper');
const { getPeriodicity } = require('../utilities/RAPortfolioHelper');

// @constants
const actionTypes = require('../raConstants/actionTypes');
const { EURO_TEXT, DATE_FORMAT_API } = require('constants/index');
const {
    CONTRIBUTION_ISBAN_PERIOD_DAILY,
    CONTRIBUTION_ISBAN_PERIOD_WEEKLY,
    CONTRIBUTION_ISBAN_PERIOD_MONTHLY,
    CONTRIBUTION_PERIOD_DAILY,
    CONTRIBUTION_PERIOD_WEEKLY,
    CONTRIBUTION_PERIOD_MONTHLY,
} = require('../raConstants/index');

// @actions
const brokerMyInvestmentsActions = require('actions/brokerMyInvestments');
const raErrorHandlerActions = require('./RAErrorHandler');
const signaturePatternActions = require('actions/signaturePattern');

const reset = () => ({
    type: actionTypes.RA_ASSOCIATE_OBJECTIVE_RESET,
});

const setSelectedAccount = (selectedAccountId, walletBalance) => ({
    type: actionTypes.RA_ASSOCIATE_OBJECTIVE_SET_ACCOUNT,
    payload: {
        selectedAccountId,
        walletBalance,
    },
});

const setFormValues = (key, value) => ({
    type: actionTypes.RA_ASSOCIATE_OBJECTIVE_SET_VALUES,
    payload: {
        key,
        value,
    },
});

const getSignaturePattern = () => {
    return {
        type: actionTypes.RA_ASSOCIATE_OBJECTIVE_GET_SIGNATURE_PATTERN,
    };
};

const recurringTrasferContributionValidationSuccess = response => ({
    type: actionTypes.RA_ASSOCIATE_OBJECTIVE_TRANSFER_VALIDATION_SUCCESS,
    payload: {
        response,
    },
});

const recurringTrasferContributionValidation = (portfolioId, history) => (
    dispatch,
    getState,
) => {
    const immAccounts = getState().accounts;
    const immProfile = getState().profile;
    const immRAAssociateObjective = getState().raAssociateObjective;
    const immGlobalPosition = getState().raGlobalPosition;
    const originAccountId = immRAAssociateObjective.get('selectedAccountId');
    const immOriginAccount = immAccounts.getIn(['byId', originAccountId]);
    const immDestinationAccount = immGlobalPosition.getIn([
        'roboAccount',
        portfolioId,
    ]);
    const recurringCode = immRAAssociateObjective.get('periodicity');
    let ibanData = [];
    immAccounts.get('byId').map(account => {
        ibanData.push({
            codIban: account.get('ibanComplex').toJS(),
        });
    });

    const oldOriginProductContract =
        immOriginAccount.get('product') +
        immOriginAccount.get('contractNumber');
    const oldOriginIbanContract = RAAccountsHelper.getOldIbanContract(
        ibanData,
        oldOriginProductContract,
    );
    const endDate = immRAAssociateObjective
        .get('investmentDate')
        .format(DATE_FORMAT_API);
    let recurringIsbanCode;

    switch (recurringCode) {
        case CONTRIBUTION_PERIOD_DAILY:
            recurringIsbanCode = CONTRIBUTION_ISBAN_PERIOD_DAILY;
            break;
        case CONTRIBUTION_PERIOD_WEEKLY:
            recurringIsbanCode = CONTRIBUTION_ISBAN_PERIOD_WEEKLY;
            break;
        case CONTRIBUTION_PERIOD_MONTHLY:
            recurringIsbanCode = CONTRIBUTION_ISBAN_PERIOD_MONTHLY;
            break;
        default:
            recurringIsbanCode = '';
    }

    const periodicities = getPeriodicity(
        recurringCode,
        immRAAssociateObjective.get('contributionDay'),
    );

    const request = {
        header: {
            version: 2,
        },
        query: {
            contratoOrdenante: {
                numeroContrato: immOriginAccount.get('newContractNumber'),
                producto: immOriginAccount.get('newProduct'),
            },
            contratoOrdenanteIban: oldOriginIbanContract,
            importe: {
                importe: immRAAssociateObjective.get(
                    'recurringContributionAmount',
                ),
                divisa: EURO_TEXT,
            },
            concepto: 'Aportación periódica destinada a la inversión',
            nombreCompletoBeneficiario: immProfile.get('fullname'),
            paisTransferencia: 'ES',
            divisaOrd: EURO_TEXT,
            indicadorResidenciaDestinatario: 'S',
            cuentaBeneficiario: !!immDestinationAccount
                ? immDestinationAccount.getIn(['ibanComplex', 'pais']) +
                  immDestinationAccount.getIn([
                      'ibanComplex',
                      'digitodecontrol',
                  ]) +
                  immDestinationAccount.getIn(['ibanComplex', 'codbban'])
                : '',
            tipoTransferencia: 'PERIODICA',
            fechaInicioVigencia: moment().format(DATE_FORMAT_API),
            indicadorPeriodicidad: {
                codigoalfanum3: recurringIsbanCode,
            },
            periodicidades: {
                periodicidad: periodicities,
            },
            fechaFinVigencia: endDate,
            indicadorTratamientoFechaEmis: 'P',
        },
    };

    return APIPost(
        dispatch,
        apiURLBuilder.getURL('transferValidation'),
        request,
    )
        .then(response => {
            dispatch(recurringTrasferContributionValidationSuccess(response));
        })
        .catch(error => {
            dispatch(raErrorHandlerActions.show(error, history));
        });
};

const addObjectiveInProgress = () => ({
    type: actionTypes.RA_ASSOCIATE_OBJECTIVE_REQUEST,
});

const addObjectiveInSuccess = (response, contributionFailure) => ({
    type: actionTypes.RA_ASSOCIATE_OBJECTIVE_SUCCESS,
    payload: {
        response,
        contributionFailure,
    },
});

const addObjective = (portfolioId, history, contributionFailure) => (
    dispatch,
    getState,
) => {
    const immRAAssociateObjective = getState().raAssociateObjective;
    const goalAmount = immRAAssociateObjective.get('goalAmount');
    const investmentTitle = immRAAssociateObjective.get('investmentTitle');
    const selectedGoal = immRAAssociateObjective
        .getIn(['selectedGoalDetail', 'id'], '')
        .toUpperCase();
    const goalDate = immRAAssociateObjective
        .get('investmentDate')
        .format(DATE_FORMAT_API);
    const maxTypeofProduct = getState().raTimeHorizonCheck.get(
        'maxTypeOfProduct',
    );
    const probability = 'NONE';

    const requestData = {
        query: {
            currency: EURO_TEXT,
            goalAmount,
            goalDate,
            goalType: selectedGoal,
            name: investmentTitle,
            maxTypeofProduct,
            portfolioId,
            probability,
        },
    };

    dispatch(addObjectiveInProgress());
    return APIPost({
        dispatch,
        endpoint: 'raAssociateObjective',
        params: requestData,
    })
        .then(response => {
            brokerMyInvestmentsActions.outdateMyInvestments()(dispatch);
            brokerMyInvestmentsActions.fetchMyInvestments()(dispatch, getState);
            dispatch(addObjectiveInSuccess(response, contributionFailure));
        })
        .catch(error => {
            dispatch(raErrorHandlerActions.show(error, history));
        });
};

const initAddObjective = (portfolioId, history) => (dispatch, getState) => {
    const immRAAssociateObjective = getState().raAssociateObjective;
    const prefilledData = immRAAssociateObjective.get('prefilledData');
    const recurringContributionAmount = immRAAssociateObjective.get(
        'recurringContributionAmount',
    );
    if (!prefilledData && recurringContributionAmount >= 1) {
        dispatch(recurringTrasferContributionValidation(portfolioId, history));
        dispatch(getSignaturePattern());
    } else {
        dispatch(addObjective(portfolioId, history));
    }
};

const recurringTrasferContributionConfirmation = (
    dispatch,
    getState,
    dataToken,
    portfolioId,
    history,
) => {
    const immAccounts = getState().accounts;
    const immProfile = getState().profile;
    const immRAAssociateObjective = getState().raAssociateObjective;
    const immGlobalPosition = getState().raGlobalPosition;
    const originAccountId = immRAAssociateObjective.get('selectedAccountId');
    const immOriginAccount = immAccounts.getIn(['byId', originAccountId]);
    const immDestinationAccount = immGlobalPosition.getIn([
        'roboAccount',
        portfolioId,
    ]);
    const oldOriginProductContract =
        immOriginAccount.get('product') +
        immOriginAccount.get('contractNumber');
    let ibanData = [];
    immAccounts.get('byId').map(account => {
        ibanData.push({
            codIban: account.get('ibanComplex').toJS(),
        });
    });

    const oldOriginIbanContract = RAAccountsHelper.getOldIbanContract(
        ibanData,
        oldOriginProductContract,
    );
    const recurringCode = immRAAssociateObjective.get('periodicity');
    const endDate = immRAAssociateObjective
        .get('investmentDate')
        .format(DATE_FORMAT_API);
    let nextExecutionDate;
    const cutDay = immRAAssociateObjective.get('contributionDay');

    switch (recurringCode) {
        case CONTRIBUTION_PERIOD_DAILY:
            nextExecutionDate = moment().add(1, 'days');
            break;
        case CONTRIBUTION_PERIOD_WEEKLY:
            nextExecutionDate = moment().add(1, 'weeks');
            break;
        case CONTRIBUTION_PERIOD_MONTHLY:
            const cutDayDate = moment().date(cutDay);
            nextExecutionDate = moment().isBefore(cutDayDate)
                ? cutDayDate.add(1, 'months')
                : cutDayDate;
            break;
        default:
            nextExecutionDate = '';
    }

    const request = {
        query: {
            amount: immRAAssociateObjective.get('recurringContributionAmount'),
            clientName: immProfile.get('fullname'),
            currency: EURO_TEXT,
            dataToken: dataToken,
            originAccount: {
                codIban: oldOriginIbanContract,
                numberContract: immOriginAccount.get('newContractNumber'),
                product: immOriginAccount.get('newProduct'),
            },
            recurringCode,
            cutDay,
            startDate: moment()
                .add(1, 'days')
                .format(DATE_FORMAT_API),
            endDate,
            nextExecutionDate: nextExecutionDate.format(DATE_FORMAT_API),
            targetActiveAccount: {
                accountNumber: immRAAssociateObjective.getIn([
                    'recurringValidationData',
                    'actuanteBeneficiario',
                    'numeroActuante',
                ]),
                typeCode: immRAAssociateObjective.getIn([
                    'recurringValidationData',
                    'actuanteBeneficiario',
                    'codTipoActuante',
                ]),
            },
            targetCgdAccount: {
                codIban:
                    immDestinationAccount.getIn(['ibanComplex', 'pais']) +
                    immDestinationAccount.getIn([
                        'ibanComplex',
                        'digitodecontrol',
                    ]) +
                    immDestinationAccount.getIn(['ibanComplex', 'codbban']),
            },
            context: '{}', // optional parameter
        },
    };
    const params = {
        portfolioId,
    };

    return APIPost(
        dispatch,
        apiURLBuilder.getURL('raRecurringTransferConfirmation', params),
        request,
    )
        .then(() => {
            dispatch(addObjective(portfolioId, history));
            brokerMyInvestmentsActions.outdateMyInvestments()(dispatch);
            brokerMyInvestmentsActions.fetchMyInvestments()(dispatch, getState);
        })
        .catch(() => {
            dispatch(addObjective(portfolioId, history, true));
            brokerMyInvestmentsActions.outdateMyInvestments()(dispatch);
            brokerMyInvestmentsActions.fetchMyInvestments()(dispatch, getState);
        });
};

const signatureFinish = (history, portfolioId) => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        recurringTrasferContributionConfirmation(
            dispatch,
            getState,
            dataToken,
            portfolioId,
            history,
        );
    };
    signaturePatternActions.validateAndExecute(dispatch, getState, callback);
};

const setMaxTypeOfProduct = portfolioId => (dispatch, getState) => {
    const maxTypeOfProduct = getState().raGlobalPosition.getIn([
        'portfolios',
        portfolioId,
        'product',
        'typeOfProduct',
    ]);

    dispatch({
        type: actionTypes.RA_ASSOCIATE_OBJECTIVE_SET_MAX_TYPE_OF_PRODUCT,
        payload: {
            maxTypeOfProduct,
        },
    });
};

module.exports = {
    initAddObjective,
    reset,
    setSelectedAccount,
    setFormValues,
    setMaxTypeOfProduct,
    signatureFinish,
};
